import { render, staticRenderFns } from "./RegisterDetail.vue?vue&type=template&id=73065654&scoped=true"
import script from "./RegisterDetail.vue?vue&type=script&lang=js"
export * from "./RegisterDetail.vue?vue&type=script&lang=js"
import style0 from "./RegisterDetail.vue?vue&type=style&index=0&id=73065654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73065654",
  null
  
)

export default component.exports